import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useOverlayContext } from 'seagull';
import { useConversationBoardScope } from '~/components/ai/conversation/useConversationBoardScope';
import { pickAiSearchBoardState } from '~/hooks/reactQuery/createAiSearchStore';
import { useLocaleKeys } from '~/i18n';
import { selectedIdsFrom, selectedRowsFrom } from '~/utils/selectedRows';
import { foldBundlesIntoServices } from '../DraftsAiSearch/hooks/draftsBundleFold';
import { useDraftsAiSearchStore } from '../DraftsAiSearch/hooks/useDraftsAiSearchStore';
import { restorableDraftIds } from '../DraftsDashboard.utils';
// WHY the fold: useBundlesFoldedIntoServices rewrites a bundles-carrying filter a tick after it is stored, which would otherwise read as the seller moving the board (ANCR-5802).
const narrowingOf = (param)=>{
    let { filter } = param;
    return filter == null ? null : foldBundlesIntoServices(filter);
};
export const useDraftsBoardScope = (param)=>{
    let { getSelectedRows, setSelected, handedBackToastTestId } = param;
    const { t } = useLocaleKeys('ai.drafting.messages');
    const { showSuccessToast } = useOverlayContext();
    const boardScope = useConversationBoardScope(narrowingOf);
    const readBoardScope = ()=>({
            search: pickAiSearchBoardState(useDraftsAiSearchStore.getState()),
            selectedIds: selectedIdsFrom(getSelectedRows())
        });
    const applyFilter = (filter, lastQuery)=>{
        const board = readBoardScope();
        useDraftsAiSearchStore.getState().setFilter(filter, lastQuery);
        boardScope.rememberStamp(board, readBoardScope());
    };
    const applySelection = (ids)=>{
        const board = readBoardScope();
        boardScope.rememberStamp(board, _object_spread_props(_object_spread({}, board), {
            selectedIds: ids
        }));
        setSelected(selectedRowsFrom(ids));
    };
    return {
        applyFilter,
        applySelection,
        restore: (scope)=>{
            const boardFilter = useDraftsAiSearchStore.getState().filter;
            if (scope.currentFilter != null && boardFilter == null) applyFilter(scope.currentFilter, '');
            const checkedCount = selectedIdsFrom(getSelectedRows()).length;
            const restoredIds = restorableDraftIds(scope, boardFilter, checkedCount);
            if (restoredIds != null) applySelection(restoredIds);
        },
        handBack: ()=>{
            const handedBack = boardScope.handBack(readBoardScope());
            // WHY abort first: a parse still in flight resolves into setFilter and would land on top of the board we just restored, exactly as clearFilter guards against (ANCR-5802).
            if (handedBack.search != null) {
                var _useDraftsAiSearchStore_getState_abortInFlight, _useDraftsAiSearchStore_getState;
                (_useDraftsAiSearchStore_getState_abortInFlight = (_useDraftsAiSearchStore_getState = useDraftsAiSearchStore.getState()).abortInFlight) === null || _useDraftsAiSearchStore_getState_abortInFlight === void 0 ? void 0 : _useDraftsAiSearchStore_getState_abortInFlight.call(_useDraftsAiSearchStore_getState);
                useDraftsAiSearchStore.setState(_object_spread_props(_object_spread({}, handedBack.search), {
                    abortInFlight: null,
                    errorCode: null
                }));
            }
            if (handedBack.selectedIds != null) setSelected(selectedRowsFrom([
                ...handedBack.selectedIds
            ]));
            if (handedBack.search != null || handedBack.selectedIds != null) {
                showSuccessToast(t.boardHandedBack(), handedBackToastTestId);
            }
        },
        forget: boardScope.forget
    };
};
